import { z } from 'zod';
import { FindOperator, LessThan } from 'typeorm';

export const UINT_8_ARRAY_SCHEMA = z
  .instanceof(Uint8Array)
  .transform(array => {
    return new Uint8Array(array);
  });

export const LESS_THAN_SCHEMA = z
  .object({
    _value: z.coerce.number(),
    _type: z.literal('lessThan'),
  })
  .transform(operator => {
    return LessThan(operator._value);
  });

export const FIND_OPTIONS_ORDER_VALUE_SCHEMA = z.union([
  z.literal('ASC'),
  z.literal('DESC'),
]);  
